export const AUDIT_LOGS_CONSTANTS = {
  HAS_NO_BODY: 'N/A',
  ACTIONS: ['CREATE', 'UPDATE', 'DELETE']
};
